import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Main from './Main';
import './helpers/initFA';
import { isChunkLoadError, hasAlreadyAttemptedChunkReload, attemptChunkReload } from './helpers/chunkErrorRecovery';

// Filet de sécurité pour les échecs de chargement de chunk qui ne passent jamais par React
// (ex: un <script> qui reçoit du HTML au lieu du JS après un déploiement — erreur levée en
// dehors de la pile d'appel React, donc invisible pour un ErrorBoundary classique).
window.addEventListener('error', (event) => {
    const looksLikeChunkFailure = isChunkLoadError(event.error || { message: event.message })
        || /\.chunk\.js$/i.test(event.filename || '')
    if (looksLikeChunkFailure && !hasAlreadyAttemptedChunkReload()) {
        attemptChunkReload()
    }
})

window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason) && !hasAlreadyAttemptedChunkReload()) {
        attemptChunkReload()
    }
})

ReactDOM.render(
  <Main>
    <App />
  </Main>,
  document.getElementById('main')
);
